/**
 * O BOTÃO DE COPIAR CÓDIGO do admin atual (`copiarCodigoParaAreaDeTransferencia`,
 * `admin.html:7646` a `7655`; peça transversal 11): SÓ O ÍCONE, e depois de copiar o ícone vira o
 * visto por 1,5 s. Falha de cópia só vai ao console.
 *
 * POR QUE O DESENHO É DAQUI: o `IconeCopiar` e o `IconeVisto` do Chassi não saem pelo índice do
 * `@complexity/ui`, e o `BotaoCopiar` do Chassi escreve o rótulo ao lado e fica 2 s, que é outro
 * gesto. O desenho abaixo é o MESMO SVG do legado (o retângulo sobre o retângulo, e a polilinha do
 * visto), em traço `currentColor`, então a cor sai dos tokens. O botão é a peça `Botao` do Chassi.
 *
 * Dona desta peça: a frente A5 (Financeiro e Sistema).
 */

// Estado e efeito do React.
import { useEffect, useState } from 'react';
// O botão do Chassi, que traz o alvo de 44 px.
import { Botao } from '@complexity/ui';

export function BotaoCopiarCodigo({ codigo }: { readonly codigo: string }) {
  const [copiado, setCopiado] = useState(false);
  useEffect(() => {
    if (!copiado) return;
    // 1500 ms: o tempo do visto no legado.
    const relogio = window.setTimeout(() => setCopiado(false), 1500);
    return () => window.clearTimeout(relogio);
  }, [copiado]);
  return (
    <Botao
      variante="fantasma"
      tamanho="icone"
      // O nome e a dica do legado, iguais nos dois (`admin.html:7193`).
      title="Copiar código"
      aria-label="Copiar código"
      data-testid="copiar-codigo"
      data-copiado={copiado ? 'sim' : 'nao'}
      /**
       * A classe `copiado` do legado pinta o visto de verde; aqui a cor de sucesso do token.
       *
       * O `!` É NECESSÁRIO, e foi medido em 07/10/2026: a variante `fantasma` do `Botao` declara a
       * própria cor de texto, e ela vencia esta classe. O visto aparecia na cor do texto comum
       * onde devia aparecer na de sucesso, e ninguém percebia, porque o ícone trocava e dava a
       * impressão de que tinha funcionado.
       *
       * É o mesmo defeito que a regra da cor de marca descreve: a cor certa no token, a classe
       * certa no elemento, e uma regra de componente vencendo a disputa em silêncio. Aqui, como
       * lá, a cor que comunica estado não pode ser desligada por quem desenha o botão.
       */
      className={copiado ? '!text-sucesso' : ''}
      onClick={() => {
        navigator.clipboard
          .writeText(codigo)
          .then(() => setCopiado(true))
          .catch((erro: unknown) => console.warn('Erro ao copiar código:', erro));
      }}
    >
      {/* 14 px, o tamanho do legado; `aria-hidden` porque o nome já está no botão. */}
      <svg
        aria-hidden="true"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {copiado ? (
          <polyline points="20 6 9 17 4 12" />
        ) : (
          <>
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </>
        )}
      </svg>
    </Botao>
  );
}
